import { render, staticRenderFns } from "./addauser.vue?vue&type=template&id=28c92516&scoped=true"
import script from "./addauser.vue?vue&type=script&lang=js"
export * from "./addauser.vue?vue&type=script&lang=js"
import style0 from "./addauser.vue?vue&type=style&index=0&id=28c92516&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c92516",
  null
  
)

export default component.exports